<template>
  <div class="list-block">
    <div class="option"
         :class="{available, active, unavailable: !available}"
         @mouseover="hover = true"
         @mouseleave="hover = false"
    >
      <div class="option-title">
        <span>
          {{ name }}
          <img src="../../assets/question-icon.svg"
               alt=""
               v-if="available && toolTip"
               v-b-tooltip.hover.right="toolTip"
          />
        </span>
      </div>
      <figure>
        <img class="img-fluid" :src="getImage(slug  + '.png')" alt="">
      </figure>
      <button v-if="available" @click="toggle">{{ $t('powerpack.steps.step3.next') }} <span>&#10132;</span></button>
    </div>
  </div>
</template>

<script>
import tooltipMixin from "../../mixins/tooltipMixin";

import {mapGetters, mapState} from 'vuex';

export default {
  name: 'MotorOption',

  mixins: [
    tooltipMixin
  ],

  data() {
    return {
      hover: false,
    }
  },

  props: ['name', 'slug'],

  computed: {
    ...mapState({
      selectedMotorGroup: (state) => state.preference.selectedMotorGroup,
    }),
    ...mapGetters({
      allValves: "valves/getAll",
      allPumps: "pumps/getAll",
      openFrameOptions: "openFrameOptions/getAll",
      selectedMotor: "build/getMotor",
      isMagento: "preference/isMagento",
    }),
    available() {
      let available = false;

      this.selectedMotorGroup.motors.forEach(motor => {
        if (motor[this.slug]) {
          available = true;
        }
      });

      return available;
    },

    active() {
      return this.$store.state.preference.motorOptions[this.slug];
    },

  },

  methods: {
    findFirstInCollectionBySlug(values, slug) {
      const collection = Array.isArray(values) ? values : Object.values(values);

      return collection.find((valve) => {
        return valve[slug];
      });
    },
    async toggle() {
      if (this.available) {
        for (let i = 0; i < this.selectedMotorGroup.motors.length; i++) {
          const motor = this.selectedMotorGroup.motors[i];
          if (motor[this.slug]) {
            await this.$store.dispatch('preference/selectMotor', motor);
            await this.$store.dispatch('build/selectMotor', motor.id);
            break;
          }
        }

        await this.$store.dispatch('preference/setMotorOption', this.slug);
        await this.$store.dispatch('build/setBestPump');

        if (this.slug !== 'and_pump') {
          await this.$store.dispatch('build/setBestTank');
        }

        if (this.slug === 'open_frame') {
          let valve = this.findFirstInCollectionBySlug(this.allValves, this.slug);

          if (valve !== undefined) {
            this.$store.commit('build/valves/dropValves');
            this.$store.commit('build/valves/addValve', valve.id);
          }

          let pump = this.findFirstInCollectionBySlug(this.allPumps, this.slug);

          if (pump !== undefined) {
            this.$store.commit('build/setPump', pump.id);
          }
          if (this.selectedMotor.motor_type === 'vtwin') {
            this.openFrameOptions.forEach(option => {
              if (option.type === 'open_frame_upper') {
                option.selected = true;
              }
              if (option.type === 'open_frame_fuel_tank') {
                option.selected = true;
              }
            })
          }
        }

        if (this.slug === 'closed_frame') {
          this.$store.commit('build/valves/dropValves');

          let pump = this.findFirstInCollectionBySlug(this.allPumps, this.slug);

          if (pump !== undefined) {
            this.$store.commit('build/setPump', pump.id);
          }
        }

        if (this.slug === 'mini_powerpack' || this.slug === 'industrial') {
          this.$store.commit('build/setCircuit', 5);
        } else {
          this.$store.commit('build/setCircuit', null);
        }

        if (this.slug !== 'open_frame') {
          this.$store.commit('build/valves/dropValves');
        }

        if (this.isMagento) {
          this.$router.push({name: 'powerpack-generator'});

          return;
        }

        this.$router.push({name: 'powerpack-configurator'});
      }
    },
  }
}
</script>

<style lang="scss">
.list-block {
  max-width: 270px;
  margin: 0 10px 15px;

  &:first-child {
    margin-left: 10px;

    @media only screen and (max-width: 1110px) {
      margin-left: 10px;
    }
  }

  .option {
    text-align: center;
    opacity: 0.3;
    user-select: none;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    overflow: hidden;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
    max-height: 206px;
    max-width: 270px;
    min-height: 206px;
    width: 270px;
    height: 100%;
    transition: all ease 0.3s;
    position: relative;

    button {
      height: 46px;
      width: 100%;
      border: none;
      color: white;
      text-transform: uppercase;
      font-size: 14px;
      display: flex;
      justify-content: space-evenly;
      align-content: center;
      align-items: center;
      cursor: pointer;
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      transition: all ease-in 0.3s;
      will-change: transform;

      span {
        transform: scale(1.5);
      }
    }

    &.active {

      .option-title {
        color: black;

        &:after {
          width: 100%;
        }
      }
    }

    &:hover {
      button {
        transition: all ease-out 0.3s;
        background-color: #71BC03;
        transform: translateY(-100%);
      }
    }

    .option-title {
      width: 100%;
      padding: 8px 15px;
      text-align: center;
      font-family: neue-haas-grotesk-display, sans-serif;
      font-style: normal;
      font-size: 14px;
      font-weight: unset;
      background: #EBEBEB;
      position: relative;
      transition: all ease 0.3s;
      color: #212529;

      span {
        position: relative;
        z-index: 2;
      }

      &:after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 0;
        background: #EBEBEB;
        transition: all ease 0.3s;
      }
    }

    figure {
      display: flex;
      justify-content: center;
      text-align: center;
      align-items: center;
      align-content: center;
      flex-grow: 1;
      padding: 14px 30px 20px;
      background-color: white;
      margin: 0;

      img {
        max-width: 180px;
        max-height: 135px;
      }
    }

    &.available {
      opacity: 1;
    }

    &.unavailable {
      cursor: not-allowed;
      border: none;
    }
  }
}

.fade-enter-active {
  transition: opacity 0.5s;
}

.fade-enter {
  opacity: 0;
}
</style>
